import FormJaivana from 'dashboard_jaivana_v1';
/**
 *
 * @author Santiago_Hernandez
 * @updateBy Sebastian Rios Echverri
 * Versiones corregidas: 1.01.0054
 */
/**
 * Custom con funciones adicionales al formulario de Investigación y desarrollo (REFORMULACIÓN)
 **/
class CustomMaquinasReciepientePeso extends FormJaivana.form {
    constructor(props) {
        super(props);
        this.initForm                   = this.initForm.bind(this);
        this.successDatosFicha          = this.successDatosFicha.bind(this);
        this.etapasFicha                = this.etapasFicha.bind(this);
        this.successEtapasFicha         = this.successEtapasFicha.bind(this);
        this.successtraerOperarios      = this.successtraerOperarios.bind(this);
        this.selectOperario             = [];
        this.setSelectOperario          = this.setSelectOperario.bind(this);
        this.successOperarios           = this.successOperarios.bind(this);
        this.valueChangeOperario        = this.valueChangeOperario.bind(this);
        this.guardarOperarioSeleccionado            = this.guardarOperarioSeleccionado.bind(this);
        this.successGuardarOperarioSeleccionado    = this.successGuardarOperarioSeleccionado.bind(this);
        this.successtraerMaquinas                   = this.successtraerMaquinas.bind(this);
        this.selectMaquinas                         = [];
        this.setSelectMaquina                       = this.setSelectMaquina.bind(this);
        this.successMaquina                         = this.successMaquina.bind(this);
        this.valueChangeMaquina                     = this.valueChangeMaquina.bind(this);
        this.guardarMaquinaSeleccionada             = this.guardarMaquinaSeleccionada.bind(this);
        this.successGuardarMaquinaSeleccionada      = this.successGuardarMaquinaSeleccionada.bind(this);
        this.successtraerRecipientes                = this.successtraerRecipientes.bind(this);
        this.selectRecipientes                      = [];
        this.setSelectRecipiente                    = this.setSelectRecipiente.bind(this);
        this.successRecipiente                      = this.successRecipiente.bind(this);
        this.valueChangeRecipiente                  = this.valueChangeRecipiente.bind(this);  
        this.guardarRecipienteSeleccionado          = this.guardarRecipienteSeleccionado.bind(this);  
        this.successGuardarRecipienteSeleccionado   = this.successGuardarRecipienteSeleccionado.bind(this);
        this.pesoChange                             = this.pesoChange.bind(this);
        this.setPeso                                = this.setPeso.bind(this);
        this.terminarEtapa                          = this.terminarEtapa.bind(this);
        this.traerDatosFicha                        = this.traerDatosFicha.bind(this);
        this.retornarOperarios                      = this.retornarOperarios.bind(this);
        this.retornaMaquinas                        = this.retornaMaquinas.bind(this);
        this.retornaRecipientes                     = this.retornaRecipientes.bind(this);  
        this.terminarFicha                          = this.terminarFicha.bind(this); 
        this.validarCeldasVacias                    = [];   
        this.verFormula                             = this.verFormula.bind(this);
        this.successVerFormula                      = this.successVerFormula.bind(this);
        this.gridOptionsVerFormula                  = Object.assign({}, this.gridOptions);
        this.cancelarFicha                          = this.cancelarFicha.bind(this);
        this.successClose                           = this.successClose.bind(this);
    }

    initForm(){
        console.log('CustomMaquinasReciepientePeso, @version: 1.01.0054, @author:Santiago_Hernandez, @updated: Sebastian Rios E.');
        this.getField('btnTerminar').setClick(this.terminarEtapa);  
        //this.getField('cancelar_ficha').setSuccess(this.terminarFicha);
        this.getField('cancelar_ficha').setClick(this.cancelarFicha); 
        this.traerDatosFicha();   
        this.getField('btn_verformula').setClick(this.verFormula);
    }

    verFormula(){
        let datos = {
            datos:{
                value: this.props.data.id_ficha,
            }
        }

        this.generalFormatPmv = { tipo_servicio: 'prod-fichas', operacion: 'verformula', operacion_tipo: 'consulta' };
        this.service.send(
        {
            endpoint: this.constant.formConfiguration(),
            method:'GET',
            body: datos,
            success: this.successVerFormula,
            error: this.error_,
            showMessage: false,
            general: this.generalFormatPmv
        });
    }

    successVerFormula(data){
        if (data.estado_p === 200 && data.data.length >= 1) {
            this.getField('modal_verformula').handleClickOpen();
            this.getField('tb_verformula').toggle(true);
            this.gridOptionsVerFormula['rowData'] = data.model;
            let configCell = new Map();
            configCell.set('nombre_articulo',{headerName: 'Nombre Artículo'});
            configCell.set('version',{headerName: 'Versión'});
            configCell.set('produccion_formulas_versiones',{headerName: 'Producción Fórmulas Versiones'});
            configCell.set('estado_descripcion',{headerName: 'Estado Descripción'});
            this.getField('tb_verformula').initData(this.gridOptionsVerFormula, configCell);
        }else if (data.estado_p === 404){
            this.alertGeneral.toggle(true,'No hay datos',"error");
            this.getField('tb_verformula').toggle(true);
            this.getField('modal_verformula').handleClose();
        }else{
            this.alertGeneral.toggle(true,'Error al consumir el servicio.',"error");
            this.getField('tb_verformula').toggle(true);
            this.getField('modal_verformula').handleClose();
        }
    }

        terminarFicha(data){
            if(data.estado_p === 200) this.successClose(data);            
        }

        traerDatosFicha(){
            let datos = {
                datos:{
                    value: this.props.data.id_ficha, 
                }
            }
            this.generalFormatPmv = { tipo_servicio: 'prod-fichas', operacion: 'iddatos', operacion_tipo: 'consulta' };
            this.service.send(
            {
                endpoint: this.constant.formConfiguration(),
                method:'GET',
                body: datos,
                success: this.successDatosFicha,
                error: this.error_,
                general: this.generalFormatPmv
            });
            /*this.generalFormat.nombre_accion = '259-Busca_una_ficha_por_id'; 
            this.service.send(
                {
                    endpoint:this.constant.formConfiguration(),
                    method:'GET',
                    body:body,
                    success:this.successDatosFicha,
                    error:this.error_,
                    general: this.generalFormat
                });*/
        }
        retornarOperarios(){
            let datos = {
                datos:{
                    value: this.props.data.id_ficha, 
                }
            }
            this.generalFormatPmv = { tipo_servicio: 'prod-operarios', operacion: 'todos', operacion_tipo: 'consulta' };
            this.service.send(
            {
                endpoint: this.constant.formConfiguration(),
                method:'GET',
                body: datos,
                success: this.successtraerOperarios,
                error: this.error_,
                general: this.generalFormatPmv
            });
            /*this.generalFormat.nombre_accion = '259-Retorna_todos_los_produccion_operarios'; 
            this.service.send(
                {
                    endpoint:this.constant.formConfiguration(),
                    method:'GET',
                    body:body,
                    success:this.successtraerOperarios,
                    error:this.error_,
                    general: this.generalFormat
                });*/
        }
        retornaMaquinas(){
            let datos = {
                datos: {
                    value: this.props.data.id_ficha,
                } 
            }
            this.generalFormatPmv = { tipo_servicio: 'prod-maquinas', operacion: 'todos', operacion_tipo: 'consulta' };
            this.service.send(
            {
                endpoint: this.constant.formConfiguration(),
                method:'GET',
                body: datos,
                success: this.successtraerMaquinas,
                error: this.error_,
                general: this.generalFormatPmv
            });
            /*this.generalFormat.nombre_accion = '259-Retorna_todas_las_maquinas'; 
            this.service.send(
                {
                    endpoint:this.constant.formConfiguration(),
                    method:'GET',
                    body:body,
                    success:this.successtraerMaquinas,
                    error:this.error_,
                    general: this.generalFormat
                });*/
        }
        retornaRecipientes(){
            let datos = {
                datos:{
                    value: this.props.data.id_ficha, 
                }
            }
            this.generalFormatPmv = { tipo_servicio: 'prod-recipientes', operacion: 'todos', operacion_tipo: 'consulta' };
            this.service.send(
            {
                endpoint: this.constant.formConfiguration(),
                method:'GET',
                body: datos,
                success: this.successtraerRecipientes,
                error: this.error_,
                general: this.generalFormatPmv
            });
            /*this.generalFormat.nombre_accion = '259-Retorna_todos_los_recipientes'; 
            this.service.send(
                {
                    endpoint:this.constant.formConfiguration(),
                    method:'GET',
                    body:body,
                    success:this.successtraerRecipientes,
                    error:this.error_,
                    general: this.generalFormat
                });  */
        }

    successDatosFicha(data){   
        this.getField('proceso_id').setValue(this.props.data.proceso_id);
        this.getField('actividad_configuracion_id').setValue(this.props.data.actividad_configuracion_id);
        this.getField('actividad_id').setValue(this.props.data.actividad_id);
        this.getField('produccion_fichas_id').setValue(this.props.data.id_ficha);     
        this.retornarOperarios();
        if (data.estado_p === 200 && data.model !== undefined && data.model.length > 0){
            this.getField('lista_datos_ficha').setVisible(true);
            this.getField('lista_datos_ficha').setItemsFichas(data.model);
        }else{
            this.getField('lista_datos_ficha').setVisible(false);
        }
    }

    etapasFicha(){
        let datos = {
            datos:{
                value: this.props.data.id_ficha, 
            }
        }
        this.generalFormatPmv = { tipo_servicio: 'prod-fichasetapas', operacion: 'fichaid', operacion_tipo: 'consulta' };
        this.service.send(
        {
            endpoint: this.constant.formConfiguration(),
            method:'GET',
            body: datos,
            success: this.successEtapasFicha,
            error: this.error_,
            general: this.generalFormatPmv
        });
        /*this.generalFormat.nombre_accion = '259-Retorna_las_etapas_de_la_ficha_id'; 
        this.service.send(
        {
            endpoint:this.constant.formConfiguration(),
            method:'GET',
            body:body,
            success:this.successEtapasFicha,
            error:this.error_,
            general: this.generalFormat
        });*/
    }

    successEtapasFicha(data){
        if(data.estado_p === 200){
            let configCell = new Map();
            configCell.set('operario',{cellRenderer:this.setSelectOperario, cellStyle: { backgroundColor: "rgb(238,238,238)",borderRadius:"5px",color:'rgb(0, 86, 201)' },field: 'operario' });
            configCell.set('nombre_maquina',{cellRenderer:this.setSelectMaquina, cellStyle: { backgroundColor: "rgb(238,238,238)",borderRadius:"5px",color:'rgb(0, 86, 201)' } ,field: 'nombre_maquina' });
            configCell.set('nombre_recipiente',{cellRenderer:this.setSelectRecipiente, cellStyle: { backgroundColor: "rgb(238,238,238)",borderRadius:"5px",color:'rgb(0, 86, 201)' }, field: 'nombre_recipiente' });
            configCell.set('peso',{cellRenderer:this.setPeso,cellStyle: {textAlign: "right" },field: 'peso'});
            this.validarCeldasVacias = data.model;
            this.gridOptions['rowData'] = data.model;
            this.getField('TbEtapasFicha').initData(this.gridOptions,configCell);
        }else{
            this.getField('TbEtapasFicha').toggle(false);
        }
    }

    successtraerOperarios(data){        
        this.retornaMaquinas();
        if(data.estado_p === 200){
            this.selectOperario = data.model;
        }else{
            this.getField('fieldAlert').toggle(true,"No se tienen operarios para mostrar","error");
        }
    }

    setSelectOperario(props){
        let maquina = props.data.operario_id;
        let select = document.createElement("select");
        let div = document.createElement('div');
        //div.setAttribute('style', 'width: 100%; heigth: 100%; padding-top: 4px');
        select.setAttribute('class', 'selectStyle1');
        select.onchange = (event) => this.valueChangeOperario(event, props.data);
        select.setAttribute('id', 'mySelectOperario_');
        let opciones = this.successOperarios();
        this.valor_idOpe = 1;
        opciones.map((item) => {
            select.appendChild(item);
            if (parseInt(item.value) === maquina)
                this.valor_idOpe = parseInt(item.value);
            return null;
        })
        div.appendChild(select)
        if(maquina !== null && maquina !== undefined)
            select.value = this.valor_idOpe;
        return this.createElementJaivana(div);
    }

    successOperarios(data){
        let opcionN = document.createElement('option');
        opcionN.setAttribute('value',' ');
        opcionN.textContent = 'Ninguno';

        let datos = [opcionN];
        this.selectOperario.map((item) =>{
            let opcion = document.createElement('option');
            opcion.setAttribute('value',parseInt(item.id));
            opcion.textContent = item.nombre;
            datos.push(opcion);
            return null;
           
        })
        return datos;
    }

    valueChangeOperario(event,data){
        let id = data.id;
        let usuario_id = parseInt(event.target.value);
        this.guardarOperarioSeleccionado(id,usuario_id);
    }

    guardarOperarioSeleccionado(id,usuario_id){
        let datos = {
            datos:{
                id:id, 
                usuario_id:usuario_id,
                actividad_id: this.props.data.actividad_id
            }
        }

        this.generalFormatPmv = { tipo_servicio: 'prod-fichasetapas', operacion: 'operario', operacion_tipo: 'modificar' };
        this.service.send(
        {
            endpoint: this.constant.formConfiguration(),
            method:'PUT',
            body: datos,
            success: this.successGuardarOperarioSeleccionado,
            error: this.error_,
            general: this.generalFormatPmv
        });

        /*this.generalFormat.nombre_accion ="259-Actualiza_operario_en_la_etapa_ficha"; 
        this.service.send(
            {
                endpoint:this.constant.formConfiguration(),
                method:'PUT',
                body:body,
                success:this.successGuardarOperarioSeleccionado,
                error:this.error_,
                general: this.generalFormat
            });*/
    }

    successGuardarOperarioSeleccionado(response){
        if(response.estado_p ===200){
            this.getField('fieldAlert').toggle(true,"Acción Exitosa","success");
            this.etapasFicha(); 
        }
    }

    successtraerMaquinas(data){
        this.retornaRecipientes(); 
        if(data.estado_p === 200){
            this.selectMaquinas = data.model;
        }else{
            this.getField('fieldAlert').toggle(true,"No se tienen maquinas para mostrar","error");
        }
    }

    setSelectMaquina(props){
        let maquina = props.data.maquina_id;
        let select = document.createElement("select");
        let div = document.createElement('div');
        //div.setAttribute('style', 'width: 100%; heigth: 100%; padding-top: 4px');
        select.setAttribute('class', 'selectStyle1');
        select.onchange = (event) => this.valueChangeMaquina(event, props.data);
        select.setAttribute('id', 'mySelectOperario_');
        let opciones = this.successMaquina();
        this.valor_idMaq = 1;
        opciones.map((item) => {
            select.appendChild(item);
            if (parseInt(item.value) === maquina)
                this.valor_idMaq = parseInt(item.value);
            return null;
        })
        div.appendChild(select)
        if(maquina !== null && maquina !== undefined)
            select.value = this.valor_idMaq;
        return this.createElementJaivana(div);
    }

    successMaquina(data){
        let opcionN = document.createElement('option');
        opcionN.setAttribute('value',' ');
        opcionN.textContent = 'Ninguno';

        let datos = [opcionN];
        this.selectMaquinas.map((item) =>{
            let opcion = document.createElement('option');
            opcion.setAttribute('value',parseInt(item.id));
            opcion.textContent = item.nombre;
            datos.push(opcion);
            return null;
           
        })
        return datos;
    }

    valueChangeMaquina(event,data){
        let id = data.id;
        let maquina_id = parseInt(event.target.value);
        this.guardarMaquinaSeleccionada(id,maquina_id);
    }

    guardarMaquinaSeleccionada(id,maquina_id){
        let datos = {
            datos:{
                id:id, 
                maquina_id:maquina_id,
                actividad_id: this.props.data.actividad_id
            }
        }
        this.generalFormatPmv = { tipo_servicio: 'prod-fichasetapas', operacion: 'maquina', operacion_tipo: 'modificar' };
        this.service.send(
        {
            endpoint: this.constant.formConfiguration(),
            method:'PUT',
            body: datos,
            success: this.successGuardarMaquinaSeleccionada,
            error: this.error_,
            general: this.generalFormatPmv
        });
        /*this.generalFormat.nombre_accion ="259-Permite_modificar_la_maquina_de_una_etapa"; 
        this.service.send(
            {
                endpoint:this.constant.formConfiguration(),
                method:'PUT',
                body:body,
                success:this.successGuardarMaquinaSeleccionada,
                error:this.error_,
                general: this.generalFormat
            });*/
    }
    successGuardarMaquinaSeleccionada(response){
        if(response.estado_p ===200){
            this.getField('fieldAlert').toggle(true,"Acción Exitosa","success");
            this.etapasFicha(); 
        }
    }

    successtraerRecipientes(data){
        if(data.estado_p === 200){
            this.selectRecipientes = data.model;
            this.etapasFicha();
        }else{
            this.getField('fieldAlert').toggle(true,"No se tienen recipientes para mostrar","error");
            this.etapasFicha();
        }
    }

    setSelectRecipiente(props){
        let maquina = props.data.recipiente_id;
        let select = document.createElement("select");
        let div = document.createElement('div');
        //div.setAttribute('style', 'width: 100%; heigth: 100%; padding-top: 4px');
        select.setAttribute('class', 'selectStyle1');
        select.onchange = (event) => this.valueChangeRecipiente(event, props.data);
        select.setAttribute('id', 'mySelectOperario_');
        let opciones = this.successRecipiente();
        this.valor_idRec = 1;
        opciones.map((item) => {
            select.appendChild(item);
            if (parseInt(item.value) === maquina)
                this.valor_idRec = parseInt(item.value);
            return null;
        })
        div.appendChild(select)
        if(maquina !== null && maquina !== undefined)
            select.value = this.valor_idRec;
        return this.createElementJaivana(div);
    }

    successRecipiente(data){
        let opcionN = document.createElement('option');
        opcionN.setAttribute('value',' ');
        opcionN.textContent = 'Ninguno';

        let datos = [opcionN];
        this.selectRecipientes.map((item) =>{
            let opcion = document.createElement('option');
            opcion.setAttribute('value',parseInt(item.id));
            opcion.textContent = item.nombre;
            datos.push(opcion);
            return null;
           
        })
        return datos;
    }

    valueChangeRecipiente(event,data){
        let id = data.id;
        let recipiente_id = parseInt(event.target.value);
        this.guardarRecipienteSeleccionado(id,recipiente_id);
    }

    guardarRecipienteSeleccionado(id,recipiente_id){
        let datos = {
            datos:{
                id:id, 
                recipiente_id:recipiente_id,
                peso:this.peso,
                actividad_id: this.props.data.actividad_id
            }
        }
        this.generalFormatPmv = { tipo_servicio: 'prod-fichasetapas', operacion: 'recipiente', operacion_tipo: 'modificar' };
        this.service.send(
        {
            endpoint: this.constant.formConfiguration(),
            method:'PUT',
            body: datos,
            success: this.successGuardarRecipienteSeleccionado,
            error: this.error_,
            general: this.generalFormatPmv
        });
        /*this.generalFormat.nombre_accion ="259-Permite_modificar_el_recipiente_de_una_etapa"; 
        this.service.send(
            {
                endpoint:this.constant.formConfiguration(),
                method:'PUT',
                body:body,
                success:this.successGuardarRecipienteSeleccionado,
                error:this.error_,
                general: this.generalFormat
            });*/
    }

    successGuardarRecipienteSeleccionado(response){
        if(response.estado_p ===200){
            this.getField('fieldAlert').toggle(true,"Acción Exitosa","success");
            this.etapasFicha(); 
        }
    }

    setPeso(props){
        let valor_actual = props.data.peso;
        let div = document.createElement("div");
        let label = document.createElement("label");
        label.textContent = "".formatoPrecio(valor_actual);
        div.appendChild(label);
        return this.createElementJaivana(div);
    }

    pesoChange(props){
        if(props.oldValue !== parseFloat(props.newValue)){
            let maquina = props.data.nombre_recipiente;
            //let recipiente_id = props.data.recipiente_id;
            if(props.newValue !== '' && parseFloat(props.newValue)){
                if(maquina !== '' && maquina !== null){
                    this.peso = parseFloat(props.newValue);
                    //let id = props.data.id;
                    this.guardarRecipienteSeleccionado(this.peso);
                }else{
                    this.gridOptions.rowData[parseInt(props.node.id)][props.column.colId] = props.oldValue;
                    this.getField('TbEtapasFicha').refresh(this.gridOptions);
                    this.alertGeneral.toggle(true,'Debe seleccionar primero un recipiente',"error");
                }
            }else{
                if(props.newValue !== '0')
                    this.alertGeneral.toggle(true,'El campo no cumple con el formato deseado',"error");
                else
                    this.alertGeneral.toggle(true,'El valor debe ser mayor a cero',"error");
                this.gridOptions.rowData[parseInt(props.node.id)][props.column.colId] = props.oldValue;
                this.getField('TbEtapasFicha').refresh(this.gridOptions);
            }
        }
    }

    // aprobacion_cancelacion_alistamiento-devolver 

    cancelarFicha(){
        this.getField('proceso_id').setValue(this.props.data.proceso_id);
        this.getField('actividad_configuracion_id').setValue(this.props.data.actividad_configuracion_id);
        this.getField('actividad_id').setValue(this.props.data.actividad_id);
        this.getField('produccion_fichas_id').setValue(this.props.data.id_ficha);  
        this.mostrarMensajeGenerando();

        let datos = {
            datos:{
                proceso_id:this.getField('proceso_id').getValue(),
                actividad_configuracion_id:this.getField('actividad_configuracion_id').getValue(),
                actividad_id:this.getField('actividad_id').getValue(),
                produccion_fichas_id:this.getField('produccion_fichas_id').getValue(),
                observaciones_cancelacion_alistamiento: this.getField("observaciones_cancelacion_alistamiento").getValue()
            }
        }
        this.getField('cancelar_ficha').setDisabled(true);

        this.generalFormatPmv = { tipo_servicio: 'prod-aprobacioncancelacionalistamiento', operacion: 'devolver', operacion_tipo: 'modificar' };
        this.service.send(
        {
            endpoint: this.constant.formConfiguration(),
            method:'PUT',
            body: datos,
            success: this.successClose,
            error: this.error_,
            general: this.generalFormatPmv
        });
    }

    terminarEtapa(){
        this.getField('proceso_id').setValue(this.props.data.proceso_id);
        this.getField('actividad_configuracion_id').setValue(this.props.data.actividad_configuracion_id);
        this.getField('actividad_id').setValue(this.props.data.actividad_id);
        this.getField('produccion_fichas_id').setValue(this.props.data.id_ficha);  
        let seguir = true;
        this.validarCeldasVacias.map((item, i)=>{
            if (this.validarCeldasVacias[i].operario === null || 
                this.validarCeldasVacias[i].nombre_maquina === null || 
                this.validarCeldasVacias[i].nombre_recipiente === null||
                this.validarCeldasVacias[i].operario === 'Ninguno' || 
                this.validarCeldasVacias[i].nombre_maquina === 'Ninguno' || 
                this.validarCeldasVacias[i].nombre_recipiente === 'Ninguno'||
                this.validarCeldasVacias[i].operario === undefined || 
                this.validarCeldasVacias[i].nombre_maquina === undefined || 
                this.validarCeldasVacias[i].nombre_recipiente === undefined ){
                this.alertGeneral.toggle(true,`Hay campos vacios en la tabla, selecciones una opción diferente a 'Ninguno'`,"error");
                seguir = false;
            }
            return(null)
        });  
        if(seguir){
            this.mostrarMensajeGenerando();
            let datos = {
                datos:{
                    id_formulario: this.formId,
                    proceso_id:this.getField('proceso_id').getValue(),
                    actividad_configuracion_id:this.getField('actividad_configuracion_id').getValue(),
                    actividad_id:this.getField('actividad_id').getValue(),
                    produccion_fichas_id:this.getField('produccion_fichas_id').getValue(),
                }
            }
            this.getField('btnTerminar').setDisabled(true);

            // produccion_fichas_etapas-recepcionmaterial
            this.generalFormatPmv = { tipo_servicio: 'prod-fichasetapas', operacion: 'recepcionmaterial', operacion_tipo: 'modificar' };
            this.service.send(
            {
                endpoint: this.constant.formConfiguration(),
                method:'PUT',
                body: datos,
                success: this.successClose,
                error: this.error_,
                general: this.generalFormatPmv
            });
            /*this.generalFormat.nombre_accion = '259-cancela_ficha'; 
            this.service.send(
                {
                    endpoint:this.constant.formConfiguration(),
                    method:'PUT',
                    body:body,
                    success:this.successCloseEstage,
                    error:this.error_,
                    general: this.generalFormat
                });*/
        } 
    }

    successClose(data){
        this.getField('confirmModalCustom').toggle(false);
        this.successCloseEstage(data);
        this.getField('btnTerminar').setDisabled(false);
        this.getField('cancelar_ficha').setDisabled(false);
    }

    mostrarMensajeGenerando() {
        this.getField('confirmModalCustom').toggle(false);
        this.getField('confirmModalCustom').setTitleAndContent('Advertencia', `No recargue la página, por favor espere, se está generando la información... `);
        this.getField('confirmModalCustom').setClickDialog(() => { });
        this.getField("confirmModalCustom").setVisibleCancel(true); // Para no mostrar el botón de cancelar en los ConfirmDialog
        this.getField("confirmModalCustom").setButtonConfirm("."); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
        this.getField('confirmModalCustom').toggle(true);
    }
}

FormJaivana.addController("prod-maquinas",CustomMaquinasReciepientePeso );
export default CustomMaquinasReciepientePeso ;